import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportSteps = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 67,
	height: 62,
	fill: "none",
	viewBox: "0 0 67 62",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 55,
			height: 49,
			x: 11.3,
			y: 11.6,
			fill: "#4A5B50",
			stroke: "#AAFBB2",
			rx: 4.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#66C870",
			d: "M44.4 28.6c0-1 1-2 2-2h12a2 2 0 0 1 1.9 1.2l3.9 8.3a2 2 0 0 1 0 1.7l-3.9 7.4c-.3.7-1 1.1-1.8 1.1h-12a2 2 0 0 1-2-2V28.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#8EE597",
			d: "M28.4 28.6c0-1 .9-2 2-2h12a2 2 0 0 1 1.9 1.2L48 36a2 2 0 0 1 0 1.7l-3.8 7.4c-.4.7-1 1.1-1.8 1.1H30.4a2 2 0 0 1-2-2V28.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#AAFBB2",
			d: "M13.5 28.6c0-1 1-2 2-2h12a2 2 0 0 1 1.9 1.2l3.9 8.3a2 2 0 0 1 0 1.7l-3.9 7.4c-.3.7-1 1.1-1.8 1.1h-12a2 2 0 0 1-2-2V28.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeLinecap: "round",
			d: "m19.7 37.5.7 1a1 1 0 0 0 1.7 0l2.4-3.4M36 37.5l.8 1a1 1 0 0 0 1.6 0l2.5-3.4M51 37.5l.6 1a1 1 0 0 0 1.7 0l2.4-3.4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 11.1,
			r: 10.7,
			fill: "#FFAB00"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m8.5 14 2.5-2 1.5-1.8c.4-.7.6-1.3.6-1.9 0-.5-.1-1-.4-1.2-.3-.4-.7-.5-1.2-.5s-1 .2-1.2.5c-.3.4-.5.9-.5 1.5H7.7c0-1.3.4-2.3 1-3a4 4 0 0 1 2.8-1c1.3 0 2.2.4 2.8 1 .7.7 1 1.6 1 2.6 0 .8-.2 1.6-.6 2.4-.5.8-1 1.4-1.6 2l-2.2 2h4.7v1.8h-8v-1.6l1-.7Z"
		})
	]
});
export default SvgReportSteps;
